<app-linechart [setOptions]="null" [value]="null">
</app-linechart>
<div class="centered">
    {{'Keine aktuellen Daten vorhanden'}}
</div>
